import React from 'react';
import '../../scss/controls/_button.scss';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export enum ButtonTheme {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    TertiaryBudget = 'tertiary-budget',
    Choice = 'choice',
    Decline = 'decline',
    LinkBlue = 'linktheme blue',
    LinkRed = 'linktheme red',
    HighlightedGrey = 'highlighted grey',
    SectionHeaderBarButton_Blue = 'sectionHeaderBarButton blue',
}

export enum ButtonBorderRadius {
    None = 'borderRadius-none',
    Small = 'borderRadius-small',
    Medium = 'borderRadius-medium',
    Large = 'borderRadius-large',
}

export const Button: React.FC<{
    id: string;
    dataTestid?: string;
    theme?: ButtonTheme;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    handleClick?: React.MouseEventHandler;
    hint?: string;
    width?: string;
    height?: string;
    maxWidth?: string;
    visible?: boolean;
    children: any;
    borderRadius?: ButtonBorderRadius;
    icon?: IconDefinition;
}> = ({
    id,
    dataTestid,
    theme = ButtonTheme.Primary,
    handleClick,
    hint,
    disabled = false,
    type = 'button',
    width = 'auto',
    height = null,
    maxWidth = 'auto',
    visible = true,
    children,
    borderRadius = ButtonBorderRadius.Large,
    icon,
}) => {
    const getThemeHeight = (currentTheme: ButtonTheme) => {
        switch (currentTheme) {
            case ButtonTheme.Primary:
            case ButtonTheme.Decline:
            case ButtonTheme.LinkBlue:
            case ButtonTheme.LinkRed:
                return '48px';
            case ButtonTheme.Tertiary:
            case ButtonTheme.Secondary:
                return '38px';
            case ButtonTheme.Choice:
                return '68px';
            default:
                return '48px';
        }
    };

    const setStyle = {
        cursor: `${!handleClick || disabled ? 'auto' : 'pointer'}`,
        width: width,
        height: height ? height : getThemeHeight(theme),
        maxWidth: maxWidth,
        visibility: visible ? 'visible' : 'hidden',
    };

    return (
        <button
            id={id}
            data-testid={dataTestid}
            className={`standardButton ${borderRadius} ${theme} ${disabled ? 'disabled' : 'active'}`}
            style={setStyle}
            onClick={handleClick}
            title={hint}
            type={type}
            disabled={disabled}
        >
            {icon && (
                <FontAwesomeIcon
                    icon={icon}
                    style={{ paddingRight: '8px' }}
                />
            )}
            {children}
        </button>
    );
};
